import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    defaultProps: {},
    styleOverrides: {
        root: {
            "svg[name=usersettings]": {
                width: "20px",
                height: "20px",
                margin: "2px",
            },
            "svg[name=crm-button]": {
                height: "34px",
                width: "34px",
                margin: "-5px",
            },
        },
    },
})
